import {
  AppointmentTemplateFragment,
  AppointmentType,
  AppointmentUserV2Fragment,
  CareType,
} from '../../graphQL';
import { Nullable } from '../../types';
import {
  findStatusByCareType,
  UserWithAppointmentStatuses,
} from '../../utils/careTypeAppointmentStatuses';
import { AppointmentDetails } from './types';

export const findIntakeApptTemplate = (
  careType: CareType,
  templates: AppointmentTemplateFragment[]
) => {
  return templates.reduce((result, template, idx) => {
    const hasCareType = template.careType === careType;
    const isIntake = template.appointmentType === 'intake';
    return hasCareType && isIntake ? ([template, idx] as const) : result;
  }, null as Nullable<readonly [AppointmentTemplateFragment, number]>);
};

export const canBookIntake = (careType: CareType, patient: UserWithAppointmentStatuses) => {
  const status = findStatusByCareType(patient.careTypeAppointmentStatuses, careType);
  if (!status) return false;
  return !status.upcomingAppointment && !status.completedAppointment;
};

export const getInitialAppointmentDetails = (
  user: AppointmentUserV2Fragment,
  careType: CareType
) => {
  const { appointmentTemplates } = user;
  const appointmentType = determineAppointmentType(user, careType);

  return appointmentTemplates.reduce((details, template, templateIndex) => {
    const hasCareType = template.careType === careType;
    const hasApptType = template.appointmentType === appointmentType;

    if (hasCareType && hasApptType) {
      return {
        appointmentType,
        templateIndex,
        careType,
        duration: template.duration,
      } as AppointmentDetails;
    }

    return details;
  }, null as Nullable<AppointmentDetails>);
};

// FIXME: https://mantrahealthpde.atlassian.net/browse/PDE-558
const determineAppointmentType = (user: AppointmentUserV2Fragment, careType: CareType) => {
  const status = findStatusByCareType(user.careTypeAppointmentStatuses, careType);
  return status?.completedAppointment ? AppointmentType.Checkin : AppointmentType.Intake;
};

export const getIntakeApptData = (
  careType: CareType,
  appointmentTemplates: AppointmentTemplateFragment[]
) => {
  const result = findIntakeApptTemplate(careType, appointmentTemplates);
  if (!result) return;
  const [template, templateIndex] = result;
  return {
    templateIndex,
    duration: template.duration,
    careType,
    appointmentType: 'intake',
  };
};
